const routes = [
    {
        path: '/system/routes',
        component: () => import('../pages/routes/Index'),
        meta: {
            isAuthenticated: true,
            isAdmin: true
        }
    }
]

export default routes;
